<template>
  <footer class="bg-primary text-primary-foreground mt-12">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <div class="flex flex-col sm:flex-row items-center justify-between gap-4">
        <div class="flex items-center gap-6">
          <router-link
            :to="localePath('About')"
            class="text-sm hover:text-primary-foreground/90 transition-colors"
          >
            {{ $t('nav.about') }}
          </router-link>
          <router-link
            :to="localePath('Privacy')"
            class="text-sm hover:text-primary-foreground/90 transition-colors"
          >
            {{ $t('nav.privacy') }}
          </router-link>
          <router-link
            :to="localePath('Terms')"
            class="text-sm hover:text-primary-foreground/90 transition-colors"
          >
            {{ $t('nav.terms') }}
          </router-link>
        </div>
        <div class="flex items-center gap-6">
          <p class="text-sm text-primary-foreground/70">Hai Afară!</p>
          <LanguageSwitcher />
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { useLocalePath } from '../composables/useLocalePath'
import LanguageSwitcher from './LanguageSwitcher.vue'

const { localePath } = useLocalePath()
</script>
